import { render, staticRenderFns } from "./DemographyMunicipalitiesGrid.vue?vue&type=template&id=72461da6&"
import script from "./DemographyMunicipalitiesGrid.vue?vue&type=script&lang=js&"
export * from "./DemographyMunicipalitiesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports